module.exports = __webpack_public_path__ + "img/2.669c56ea.png";